<mat-dialog-content id="dialog-content">
  <div *ngIf="showSelection && !showInputBox">
    {{ data.loginConfig?.whatTypeInstructionText || 'What type of user are you?' }}
  </div>
  <div *ngIf="!showSelection && showInputBox">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>UserName/Barcode </mat-label>
      <input
        matInput
        #userInput
        type="text"
        placeholder="Enter Username/Barcode"
        name="userName"
        [(ngModel)]="userName"
      />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container *ngIf="showSelection && !showInputBox">
    <button
      mat-button
      role="button"
      [disabled]="submitting"
      aria-label="Submit Patron"
      class="ag-mat-button-primary"
      type="submit"
      (click)="submit('patron')"
    >
      {{ data.loginConfig?.whatTypePatronLabel || 'Patron' }}
    </button>
    <button
      mat-button
      role="button"
      [disabled]="submitting"
      aria-label="Submit Staff"
      class="ag-mat-button-primary"
      type="button"
      (click)="submit('staff')"
    >
      {{ data.loginConfig?.whatTypeStaffLabel || 'Staff' }}
    </button>
  </ng-container>

  <ng-container *ngIf="!showSelection && showInputBox">
    <button
      mat-button
      [disabled]="submitting"
      role="button"
      aria-label="Submit Staff"
      class="ag-mat-button-primary"
      autocomplete="off"
      type="button"
      (click)="submitUserName()"
    >
      <ng-container *ngIf="!submitting">Submit</ng-container>
      <mat-icon *ngIf="submitting">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-icon>
    </button>
    <button
      mat-button
      role="button"
      aria-label="Go Back"
      type="button"
      (click)="goBack()"
      [disabled]="submitting"
    >
      Go Back
    </button>
  </ng-container>
</mat-dialog-actions>
